<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <el-form-item>
        <el-input placeholder="请输入关键字" v-model="serchModel.bidsName"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="default" icon="el-icon-search" @click="getBidsList"></el-button>
      </el-form-item>
      <el-form-item class="page-panel-search-form-right-button">
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <ul class="article-list">
      <li class="article-list_item" v-for="(item,index) in bidsList" :key="index">
        <div class="article-list-item__body">
          <div class="article-list-item__index"><i class="index">{{index+1+((serchModel.pageNo-1))*10}}</i></div>
          <div class="article-title">
            <span class="article-title_type">[{{getType(item.bidsType)}}]</span>
            <a class="article-title__name" href="javascript:;" @click="edit(item.bidsId)">{{item.bidsName}}</a>
            <div class="article-title__icons" v-if="item.bidsKeys">
              <el-tag size="mini" class="article-title-icon">{{item.bidsKeys}}</el-tag>
            </div>
          </div>
          <div class="article-attrs">
            <span class="article-attr__item">发布日期： {{item.promTime}}</span>
          </div>
          <div class="article-attrs">
            <span class="article-attr__item_grey">公告由</span>
            <span class="article-attr__item_black">{{item.addUser}}</span>
            <span class="article-attr__item_grey">于</span>
            <span class="article-attr__item_black">{{item.addTime}}</span>
            <span class="article-attr__item_grey">发布</span>

          </div>
          <div class="article-control">
            <!-- <a class="article-control__item" href="javascript:;">查看</a> -->
            <a class="article-control__item" href="javascript:;" @click="edit(item.bidsId)">编辑</a>
            <a class="article-control__item" href="javascript:;" @click="delBids(item.bidsId)">删除</a>
          </div>
        </div>
      </li>
    </ul>
    <div class="page-panel__footer">
      <el-pagination :current-page.sync='serchModel.pageNo' :page-size='serchModel.pageSize'
        layout='prev, pager, next, jumper' :total='total' @current-change='getBidsList'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as tenderApi from '@/api/adminApi/zh/tendering';
export default {
  data() {
    return {
      total: 0,
      serchModel: {
        pageNo: 1,
        pageSize: 10
      },
      bidsList: []
    };
  },
  methods: {
    add() {
      this.$router.push({
        path: '/admin/article/tendering/add'
      });
    },
    getBidsList() {
      tenderApi.getBidsList(this.serchModel).then(res => {
        this.bidsList = res.data.list;
        this.total = res.data.pageTotal;
      });
    },
    delBids(bidsId) {
      this.$confirm('是否确认删除该公告', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          tenderApi.delBids({ bidsId: bidsId }).then(res => {
            this.getBidsList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    edit(bidsId) {
      this.$router.push({
        path: `/admin/article/tendering/edit/${bidsId}`
      });
    }
  },
  computed: {
    getType() {
      return function(type) {
        switch (type) {
          case 0:
            return '普通公告';
          case 1:
            return '招标公告';
          case 2:
            return '备案告知';
          case 3:
            return '招标动态';
          case 4:
            return '政策法规';
          default:
            return 0;
        }
      };
    }
  },
  created() {
    this.getBidsList();
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/stylus/color'

.article-list .article-list_item .article-list-item__body:hover {
  .index {
    color #fff
    background-color $color-main
    left 14px
  }
  .article-title__name {
    color $color-main
  }
}
.article-list-item__index {
  float left
  margin-top 4px
  margin-right 5px
  i {
    padding-left 2px
    padding-right 2px
  }
}
.article-list-item__info {
  float left
  width 95%
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/tendering/list.vue